<template>
<!-- HEAD -->
<div class="container-xxl">
    <!-- titol -->
    <div class="row justify-content-between">
        <div class="col-12 col-lg-4 py-4 text-start">
            <p class="txtBlau2 my-0">{{ $t('site.avanzando-hacia-el-futuro')}}</p>
                <h2>{{ $t('innovacion.innovacion')}}</h2>
            </div>
            <div class="col-6 text-start py-5 d-none d-lg-block">
                <h5>{{ $t('innovacion.RG-entiende')}}</h5>
            </div>
        </div>
    </div>
    <div class="container-fluid">
        <!-- foto -->
        <div class="row">
            <div class="col-12 p-0 m-0 overflow-hidden">
                <img :src="`${publicPath}img/01avanzandoInnovacion.jpg`" class="img-responsive" id="imgCrecimiento">
            </div>
        </div>
        <div class="row d-block d-lg-none">
            <div class="col-11 mx-3 mt-3 text-start">
                <h5>{{ $t('innovacion.RG-entiende')}}</h5>
            </div>
        </div>

    </div>
    <!-- end HEAD -->

    <!-- Content -->
    <div class="container-xxl">
        <div class="franjaODS d-none d-lg-block">
            <ul>
                <li class="odsTxt">{{ $t('site.ODS-impacto-directo')}}</li>
                <li><img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods6_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive"></li>
                <li style="width: 90px"></li>
                <li class="odsTxt">{{ $t('site.ODS-impacto-indirecto')}}</li>
                <li><img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive"></li>
                <li><img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive"></li>
            </ul>

        </div>
        <div class="franjaODS d-block d-lg-none">
            <div class="row justify-content-between p-0 m-0">
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods3_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods6_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods9_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods12_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>
                </div>
                <div class="col-12 odsTxt">
                    <p class="p-0 m-0" v-html="$t('site.ODS-impacto-directo2')"></p>
                    <ul>
                        <li>
                            <img :src="`${publicPath}img/ods7_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods11_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods13_${locale}.gif`" class="img-responsive">
                        </li>
                        <li>
                            <img :src="`${publicPath}img/ods17_${locale}.gif`" class="img-responsive">
                        </li>
                    </ul>

                </div>
            </div>
        </div>

    </div>

    <div class="container-xxl">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-5 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-0 text-start">
                    <h2 class="mb-5 mt-5 mt-lg-0">{{ $t('innovacion.primer-año')}}</h2>
                    <h5 class="txtGris mb-5">{{ $t('innovacion.uno-pilares')}}</h5>
                </div>
            </div>
            <div class="col-12 col-lg-1">

            </div>
            <div class="col-12 col-lg-6 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="row">
                    <div class="col-12 my-2 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="boxGris g-3 p-5 px-4 text-center text-lg-start">
                            <div class="row">
                                <div class="col-12 col-lg-2">
                                    <svg viewBox="0 0 80 80" width="80">
                                        <use :href="`${publicPath}icons.svg#hands`"/>
                                    </svg>
                                </div>
                                <div class="col-12 col-lg-4">
                                    <h4>{{ $t('innovacion.identificacion-analisis')}}</h4>
                                </div>
                                <div class="col-12 col-lg-6">
                                    <p class="text-white">{{ $t('innovacion.tras-analizar')}}</p>
                                    <img :src="`${publicPath}img/ATR-logo.png`" class="img-responsive col-4">

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 my-2 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="boxGris g-3 p-5 px-4 text-center text-lg-start">
                            <div class="row">
                            <div class="col-12 col-lg-2">
                                <img :src="`${publicPath}img/eventos.png`" class="img-responsive" width="80">
                            </div>
                            <div class="col-12 col-lg-4 mt-2">
                                <h4>{{ $t('innovacion.participacion-eventos')}}</h4>
                            </div>
                            <div class="col-12 col-lg-6">
                                <p class="text-white">{{ $t('innovacion.la-presencia-South')}}</p>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 my-2 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="boxGris g-3 p-5 px-4 text-center text-lg-start">
                            <div class="row">
                            <div class="col-12 col-lg-2">
                                <svg viewBox="0 0 80 80" width="80">
                                    <use :href="`${publicPath}icons.svg#promocion`"/>
                                </svg>
                            </div>
                            <div class="col-12 col-lg-4">
                                <h4>{{ $t('innovacion.promocion-interna')}}</h4>
                            </div>
                            <div class="col-12 col-lg-6">
                                <p class="text-white">{{ $t('innovacion.primeras-colaboraciones')}}</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-5 borderGris">
    </div>

    <div class="container-xxl">
        <div class="row g-3 mt-2">
            <div class="col-12 col-lg-3 text-center text-lg-start">
                <h4 v-html="$t('innovacion.principales-areas')"></h4>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-up" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <svg viewBox="-10 0 90 120" width="90">
                    <use :href="`${publicPath}icons.svg#mobil`"/>
                </svg>

                <h4 class="my-3 mb-4">{{ $t('innovacion.hogares-inteligentes')}}</h4>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <svg viewBox="5 -20 92 120" width="90">
                    <use :href="`${publicPath}icons.svg#medioambiental`"/>
                </svg>

                <h4 class="my-3 mb-4">{{ $t('innovacion.sostenibilidad-medioambiental')}}</h4>
            </div>
            <div class="col-12 col-lg-3 aos-init aos-animate" data-aos="fade-up" data-aos-delay="500" data-aos-easing="easy-out" data-aos-duration="1000">
                <svg viewBox="0 -20 100 120" width="90">
                    <use :href="`${publicPath}icons.svg#productividad`"/>
                </svg>
                <h4 class="my-3 mb-4">{{ $t('innovacion.mejora-productividad')}}<br><br></h4>
            </div>
        </div>
        <div class="row justify-content-end g-3 my-5">
            <div class="col-12 col-lg-9 text-center text-lg-start">
                <h4 class="txtBlau2">{{ $t('innovacion.en-el-desarrollo')}}</h4>
            </div>
        </div>
        <hr class="borderGris">
    </div>

    <div class="container-xxl">
        <div class="row g-3">
            <div class="col-12 col-lg-4 aos-init aos-animate" data-aos="zoom" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="pt-3 text-start">
                    <h2 class="mb-5">{{ $t('innovacion.anticipacion-tendencias')}}</h2>
                    <h4>{{ $t('innovacion.RG-ha-desarrollado')}}</h4>
                </div>
            </div>
            <div class="col-12 col-lg-8 mt-5 position-relative aos-init aos-animate" data-aos="zoom" data-aos-easing="easy-out" data-aos-duration="1000">
                <div class="row g-3">
                    <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-down" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="bg-white p-5 text-start fullHeight">
                            <h4 class="h3Crecimiento mb-4 txtBlau2"><strong>{{ $t('innovacion.monitoreo-preventivo-salud')}}</strong></h4>
                            <p class="txtBlau2">{{ $t('innovacion.analisis-constante-salud')}}</p>
                            <p class="txtBlau2">{{ $t('innovacion.en-colaboracion-con')}} <img :src="`${publicPath}img/01avanzandoInnovacionLogoA.png`" WIDTH="92" class="img-responsive mx-3"></p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-down" data-aos-delay="200" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="bg-white p-5 text-start fullHeight">
                            <h4 class="h3Crecimiento mb-4 txtBlau2"><strong>{{ $t('innovacion.sistema-deteccion-caidas')}}</strong></h4>
                            <p class="txtBlau2">{{ $t('innovacion.lampara-deteccion')}}</p>
                            <p class="txtBlau2">{{ $t('innovacion.en-colaboracion-con')}} <img :src="`${publicPath}img/01avanzandoInnovacionLogoB.png`" WIDTH="92" class="img-responsive mx-3"></p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="bg-white p-5 text-start fullHeight">
                            <h4 class="h3Crecimiento mb-4 txtBlau2"><strong>{{ $t('innovacion.smart-mirror')}}</strong></h4>
                            <p class="txtBlau2">{{ $t('innovacion.espejo-inteligente')}}</p>
                            <p class="txtBlau2">{{ $t('innovacion.en-colaboracion-con')}} <img :src="`${publicPath}img/01avanzandoInnovacionLogoC.png`" WIDTH="92" class="img-responsive mx-3"></p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 aos-init aos-animate" data-aos="fade-up" data-aos-delay="400" data-aos-easing="easy-out" data-aos-duration="1000">
                        <div class="bg-white p-5 text-start fullHeight">
                            <h4 class="h3Crecimiento mb-4 txtBlau2"><strong>{{ $t('innovacion.diseño-inclusivo-universal')}}</strong></h4>
                            <p class="txtBlau2">{{ $t('innovacion.revision-oferta-productos')}}</p>
                            <p class="txtBlau2">{{ $t('innovacion.en-colaboracion-con')}} <img :src="`${publicPath}img/01avanzandoInnovacionLogoD.png`" WIDTH="92" class="img-responsive mx-3"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr class="my-5 borderGris">
    </div>

    <div class="container-xxl pb-5">
        <div class="row g-0 my-5 pt-3">
            <div class="col-12 col-lg-4 text-start aos-init aos-animate" data-aos="fade-up" data-aos-delay="100" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/01avanzandoInnovacionImgsA.jpg`" class="img-responsive">
                <h4 class="col-10 py-5 pb-3">{{ $t('innovacion.la-evolucion-icono')}}</h4>
                <p class="txtGris pe-5">{{ $t('innovacion.la-iconica-coleccion')}}</p>
            </div>
            <div class="col-12 col-lg-4 text-start aos-init aos-animate" data-aos="fade-up" data-aos-delay="300" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/01avanzandoInnovacionImgsB.jpg`" class="img-responsive">
                <h4 class="col-10 py-5 pb-3">{{ $t('innovacion.In-Wash')}}</h4>
                <p class="txtGris pe-5">{{ $t('innovacion.La-nueva-evolucion')}}</p>
            </div>
            <div class="col-12 col-lg-4 text-start aos-init aos-animate" data-aos="fade-up" data-aos-delay="400" data-aos-easing="easy-out" data-aos-duration="1000">
                <img :src="`${publicPath}img/01avanzandoInnovacionImgsC.jpg`" class="img-responsive">
                <h4 class="col-10 py-5 pb-3">{{ $t('innovacion.Hydro')}}</h4>
                <p class="txtGris pe-5">{{ $t('innovacion.Nuevo-ejemplo-integracion')}}</p>
            </div>
        </div>
        <div class="row g-0 my-5">
            <div class="col-12 col-lg-8 order-1 order-lg-0 p-5 pb-0 bg-dark text-start">
                <div class="col-12 col-lg-10 m-auto p-4 ps-2 pb-0">
                    <h4 class="mb-3">{{ $t('innovacion.Miradas-alternativas')}}</h4>
                    <p class="txtGris">{{ $t('innovacion.La-integracion')}}</p>
                </div>
            </div>
            <div class="col-12 col-lg-4 order-0 order-lg-1 bg-dark">
                <img :src="`${publicPath}img/01avanzandoInnovacionImgsD.jpg`" class="img-responsive">
            </div>
        </div>
    </div>

        <!-- end Content -->

    <!-- Footer -->
    <footer>
        <div class="row p-0 g-0">
            <div class="col-6 border-top border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/excelencia-operacional" class="row justify-content-start p-0 m-0 my-0 my-lg-5">
                    <div class="col-4 col-lg-auto p-0 ps-0 ps-lg-5 ms-0 ms-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaLeft">
                            <use :href="`${publicPath}icons.svg#fletxaLeft`"/>
                        </svg>
                    </div>
                    <div class="col-6 col-lg-auto text-start p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.anterior')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.excelencia-operacional") }}</h2>
                    </div>
                </localized-link>
            </div>
            <div class="col-6 border-top border-start border-dark">
                <localized-link to="/avanzando-hacia-el-futuro/transformacion-digital" class="row justify-content-end p-0 m-0 my-0 my-lg-5">

                    <div class="col-6 col-lg-auto text-end p-0 mt-5">
                        <h6 class="hoverEfect mt-4 mt-lg-0">{{$t('site.siguiente')}}</h6>
                        <h2 class="hoverEfect d-none d-lg-block text-uppercase">{{ $t("nav.transformacion-digital") }}</h2>
                    </div>
                    <div class="col-4 col-lg-auto p-0 pe-5 me-0 me-lg-5">
                        <svg class="hoverEfect svg-icon iconFletxaRight">
                            <use :href="`${publicPath}icons.svg#fletxaRight`"/>
                        </svg>
                    </div>

                </localized-link>
            </div>
        </div>
    </footer>
    <!-- Footer -->

</template>
<script>
    export default {
        name: "InnovacionView",
        data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale,
            }
        },
    }

</script>
